import {
  ActorProfilePreviewFragmentFragment,
  ContentItemFragmentFragment
} from '@lopo-tech/lopo-api'
import { memoize } from 'lodash'
import { getColorFromAuthorType } from '../api/decoders/marker'
import { IMarker } from '../interfaces/marker'
import { UrlUtils } from './url/url'
// interfaces

const isProfile = (
  item: ContentItemFragmentFragment | ActorProfilePreviewFragmentFragment
): item is ActorProfilePreviewFragmentFragment =>
  [
    'AuthorityProfile',
    'BlogProfile',
    'PressProfile',
    'PrivateProfile'
  ].includes(item.__typename)

export const createMarkersList = memoize(
  (
    items: Array<
      ContentItemFragmentFragment | ActorProfilePreviewFragmentFragment
    >
  ) => {
    const out: IMarker[] = []
    for (const item of items) {
      if (isProfile(item)) {
        const pos = item.marker?.coordinates
        if (!pos) continue

        out.push({
          color: getColorFromAuthorType(item.__typename),
          id: item.id,
          image: item.marker?.image?.previewUrl ?? item.avatar.previewUrl,
          position: pos,
          url: UrlUtils.getProfileFrontendPath(item.slug, item.__typename)
        })
      } else {
        const marker = item.markers?.[0]
        if (!marker) continue
        out.push({
          color: getColorFromAuthorType(item.author.__typename),
          id: item.id,
          image: marker.image?.previewUrl ?? item.author.avatar.previewUrl,
          position: marker.coordinates,
          url: UrlUtils.detailPage(item.slug, item.__typename)
        })
      }
    }
    return out
  },
  (items) => items
)
